export default "__VITE_ASSET__eOGwLEvz__"